import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const TaboolaAdHeadline = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14927)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip1_1503_14927)">
            <path
              d="M177.523 31.4856C175.534 31.4732 175.256 33.4084 175.248 34.8656C175.239 36.3227 175.494 38.2894 177.482 38.3008C179.471 38.3122 179.749 36.3522 179.757 34.8922C179.766 33.4322 179.512 31.496 177.523 31.4856ZM177.463 42.1189C172.291 42.0894 169.976 38.6541 170 34.8351C170.024 31.016 172.374 27.636 177.547 27.6675C182.719 27.6989 185.033 31.1036 185.01 34.9227C184.987 38.7417 182.633 42.1494 177.463 42.1189Z"
              fill="#0071B7"
            />
            <path
              d="M190.553 31.4848C188.565 31.4734 188.289 33.4077 188.28 34.8667C188.271 36.3258 188.525 38.2886 190.514 38.301C192.504 38.3134 192.779 36.3515 192.788 34.8924C192.796 33.4334 192.542 31.4953 190.553 31.4848ZM190.491 42.1201C185.321 42.0886 183.007 38.6534 183.029 34.8353C183.052 31.0172 185.405 27.6353 190.575 27.6667C195.746 27.6981 198.061 31.1048 198.039 34.9229C198.017 38.741 195.663 42.1486 190.491 42.1201Z"
              fill="#0071B7"
            />
            <path
              d="M171.965 42.1204C175.693 43.7861 179.562 44.5261 183.775 44.5499C188.202 44.5756 191.56 43.7394 195.812 42.1204L195.787 46.708C191.977 48.5946 187.856 49.6127 183.744 49.5889C179.268 49.5622 176.03 48.6422 171.935 46.708L171.965 42.1204Z"
              fill="#0071B7"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1503_14927">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14927">
            <rect
              width="28"
              height="28"
              fill="white"
              transform="translate(170 23)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
